export const FRANCE = 'FR';
export const GERMANY = 'DE';

export const COUNTRIES_WITH_VAT_LAWS = [FRANCE, GERMANY];

export const hasVat = (countryCode: string): boolean => {
  const country = `${countryCode}`.toUpperCase();
  return COUNTRIES_WITH_VAT_LAWS.includes(country);
};
